// src/context/ColorContext.js
import React, { createContext, useContext, useState, useEffect } from "react";
import { BASE_URL } from "../config/config";
const ColorContext = createContext();

export const ColorProvider = ({ children }) => {
  const [colors, setColors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchColors = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${BASE_URL}/color`);
      const data = await response.json();

      if (data.status === 200) {
        setColors(data.data);
      } else {
        throw new Error("Failed to load colors");
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchColors();
  }, []);

  return (
    <ColorContext.Provider value={{ colors, loading, error, fetchColors }}>
      {children}
    </ColorContext.Provider>
  );
};

export const useColors = () => useContext(ColorContext);
